import React, { useState, useEffect } from "react";
import { 
  LayoutDashboard,
  Users,
  BookA,
  Building2,
  Bell,
  Clock,
  History,
  Network ,
  Award,
  CalendarOff,
  ClipboardList,
  GraduationCap,
  UserCheck
  
} from "lucide-react";
import { FaCalendarAlt ,FaMoneyBillWave} from "react-icons/fa";
import ModuleSidebar from "./ModuleSidebar"; // Adjust path to match your file structure

const Sidebar = () => {
  const [permissions, setPermissions] = useState([]);
  const [role, setRole] = useState("");

  useEffect(() => {
    const admin = JSON.parse(localStorage.getItem("adminData")) || {};
    setPermissions(admin.permissions || []);
    setRole(admin.role || "");
  }, []);

  // Raw sections structure matching OPSidebar pattern
  const rawSections = [
    {
      title: "Home",
      id: "dashboard",
      items: [
        { 
          label: "Dashboard", 
          path: "/Dashboard", 
          icon: LayoutDashboard, 
          permission: "Dashboard_View" 
        },
      ]
    },
    {
      title: "Master",
      id: "master",
      icon: Building2,
      permission: "Master_View",
      items: [
        { label: "Departments", path: "/DepartmentMaster", icon: Network },
        { label: "Designations", path: "/DesignationMaster", icon: Award },
        { label: "Manage Shift Time", path: "/ShiftMaster", icon: Clock },
        { label: "Manage Leave Type", path: "/LeaveTypeMaster", icon: CalendarOff },
        { label: "Qualification", path: "/QualificationMaster", icon: GraduationCap },
        { label: "Department Head", path: "/DepartmrentHead", icon: UserCheck },
      ],
    },
    {
      title: "Emp Status Reminder",
      id: "reminder",
      items: [
        { 
          label: "Reminder", 
          path: "/ReminderPage", 
          icon: Bell, 
          permission: "Reminder_View" 
        },
      ]
    },
    {
      title: "Employees",
      id: "employees",
      items: [
        { 
          label: "New Employee Reg", 
          path: "/EmployeeMaster", 
          icon: Users, 
          permission: "Employee_View" 
        },
      ]
    },
    {
      title: "Leave History",
      id: "leave_mgmt",
      icon: FaCalendarAlt,
      permission: "Leave_Management_View",
      items: [
        { label: "Leave History", path: "/LeaveHistory" },
      ],
    },
    {
      title: "Shift Management",
      id: "shift_mgmt",
      icon: Clock,
      permission: "Shift_Management_view",
      items: [
        { label: "Duty Roaster", path: "/ShiftManagement" },
        { label: "Duty Roaster History", path: "/DutyRoasterHistory" },
      ]
    },
    {
      title: "Attendance",
      id: "attendance",
      icon: ClipboardList,
      permission: "Attendance_history_view",
      items: [
        { label: "HR Attendance Approval", path: "/HRApprovalAttendaceReq" },
        { label: "Attendance Controller", path: "/EmployeeAttendanceHistory" },
        { label: "Attendance History", path: "/AttendanceRegisterHistory" },
      ],
    },
    {
      title: "Pay Slip",
      id: "payslip",
      icon: FaMoneyBillWave,
      permission: "Pay_slip_view",
      items: [
        { label: "Payslip Generate", path: "/GenerateAllEmployeePayslip" },
        { label: "Payslip Print", path: "/PaySlipGenerateEmployeeList" },
        { label: "History", path: "/PaySlipHistory" },
      ]
    },
    {
      title: "Admin Panel",
      id: "admin_panel",
      icon: Users,
      permission: "Admin_Management_view",
      items: [
        { label: "Admin Management", path: "/AdminManagement" },
        { label: "Employee Management", path: "/EmployeeUserIdCreated" },
      ],
    },
    {
      title: "Activity",
      id: "activity",
      items: [
        { 
          label: "Activity History", 
          path: "/ActivityHistory", 
          icon: History, 
          permission: "Activity_History" 
        },
      ]
    },
  ];

  // Filter sections and items based on admin permissions (if 'ALL' or specific permission exists)
  const filteredSections = rawSections
    .map(section => {
      // If section has a top-level permission check
      if (section.permission && !permissions.includes("ALL") && !permissions.includes(section.permission)) {
        return null;
      }
      
      // Filter individual items inside the section based on permissions if defined
      const filteredItems = section.items.filter(item => 
        permissions.includes("ALL") || !item.permission || permissions.includes(item.permission)
      );

      if (filteredItems.length === 0) return null;

      return {
        ...section,
        items: filteredItems
      };
    })
    .filter(Boolean);

  return (
    <ModuleSidebar 
      title="DORIKA ADMIN" 
      mobileLabel="ADMIN PANEL" 
      sections={filteredSections} 
    />
  );
};

export default Sidebar;